import { Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import { NsxFooter } from '@britishgasenergy/react-nucleus';

import { RouteScreen } from './RouteScreenRevamp';
import { useBeforeUnload } from 'hooks/useBeforeUnload';
import { RedirectComponent } from './RedirectComponent';
import { PageNotFound } from './PageNotFound';
import { useRoutes } from './useRoutes';
import { usePartner } from 'components/app/routes/usePartner';
import { NsStopgap } from 'components/common/ns-stopgap/NsStopgap';

export const Routes = () => {
  const {
    isLoginEnabled,
    routes,
    shouldShowPrompt,
    shouldRedirect
  } = useRoutes();
  const { partnerPath } = usePartner();

  useBeforeUnload(shouldShowPrompt);

  return (
    <>
      <ns-header
        primary={[]}
        secondary={[]}
        secondary-banner={JSON.stringify([
          {
            text: `Switch and leave the rest to us. You won’t need to do a
                    thing!`
          }
        ])}
      ></ns-header>

      <Switch>
        {routes.map((route, i) => (
          <Route key={i} path={route.path} exact>
            {() => {
              if (shouldRedirect) {
                return <RedirectComponent path={partnerPath} />;
              }

              return (
                <Suspense fallback={<NsStopgap />}>
                  <RouteScreen
                    route={route}
                    routes={routes}
                    isLoginEnabled={isLoginEnabled}
                  />
                </Suspense>
              );
            }}
          </Route>
        ))}
        <Route path="*" render={PageNotFound} />
      </Switch>
      <NsxFooter />
    </>
  );
};
